import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const Chat = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat', 'p-5 rounded-xl border border-neutral-lightest bg-white shadow-dropshadow-sm min-h-[200px] flex-grow flex flex-col gap-3', className)}
    {...props}
  />
));
Chat.displayName = 'Chat';

const ChatBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-body', 'h-[200px] flex-grow overflow-y-auto flex flex-col-reverse pr-3 [&>.c-empty-state]:m-auto', className)}
    {...props}
  />
));
ChatBody.displayName = 'ChatBody';

const chatFooterVariants = cva('flex flex-col gap-2 rounded', {
  variants: {
    variant: {
      default: '',
      reply: 'p-3 bg-bright'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

const ChatFooter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-footer', chatFooterVariants({ variant }), className)}
    {...props}
  />
));
ChatFooter.displayName = 'ChatFooter';

const ChatForm = React.forwardRef(({ className, ...props }, ref) => (
  <form
    ref={ref}
    className={cn('c-chat-form', 'flex items-center gap-2 [&_input::placeholder]:text-neutral', className)}
    {...props}
  />
));
ChatForm.displayName = 'ChatForm';

const ChatOriginalText = React.forwardRef(({ className, variant, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-chat-original-text', 'truncate mb-0 text-neutral text-xs font-bold max-w-full', className)}
    {...props}
  />
));
ChatOriginalText.displayName = 'ChatOriginalText';

export { Chat, ChatBody, ChatFooter, ChatForm, ChatOriginalText };
